import { get } from 'env-var';
import logger from '3-foundation/Logging/logger';

let DISALLOWED_CONTENT_TYPES: Array<string>;
let NEXT_PUBLIC_SEARCH_SITE_ID_OVERRIDE: boolean;
let NEXT_PUBLIC_SEARCH_SITE_ENV: string;
let NEXT_PUBLIC_SEARCH_SITE_ID: string;
let NEXT_PUBLIC_SEARCH_CLUDO_CLIENT_ID: string;
let NEXT_PUBLIC_SEARCH_CLUDO_ENGINE_DA: string;
let NEXT_PUBLIC_SEARCH_CLUDO_ENGINE_EN: string;
let NEXT_PUBLIC_SEARCH_CLUDO_ENGINE_KL: string;

if (typeof window === 'undefined') {
	DISALLOWED_CONTENT_TYPES = [
		'siteConfigurationFolder',
		'dataFolder',
		'authorsFolder',
		'person',
		'contactPersonsFolder',
		'contactPerson',
		'organisationsFolder',
		'organisation',
		'tagsFolder',
		'tag',
		'contentFolder',
		'ctaBarItem',
		'sharedContent',
		'redirectsFolder',
		'customRedirect',
		'contentRedirect',
	];
	NEXT_PUBLIC_SEARCH_SITE_ID_OVERRIDE = get('NEXT_PUBLIC_SEARCH_SITE_ID_OVERRIDE').default('false').asBool();
	NEXT_PUBLIC_SEARCH_SITE_ENV = get('NEXT_PUBLIC_SEARCH_SITE_ENV').asString();
	NEXT_PUBLIC_SEARCH_SITE_ID = get('NEXT_PUBLIC_SEARCH_SITE_ID').asString();
	NEXT_PUBLIC_SEARCH_CLUDO_CLIENT_ID = get('NEXT_PUBLIC_SEARCH_CLUDO_CLIENT_ID').required().asString();
	NEXT_PUBLIC_SEARCH_CLUDO_ENGINE_DA = get('NEXT_PUBLIC_SEARCH_CLUDO_ENGINE_DA').required().asString();
	NEXT_PUBLIC_SEARCH_CLUDO_ENGINE_EN = get('NEXT_PUBLIC_SEARCH_CLUDO_ENGINE_EN').required().asString();
	NEXT_PUBLIC_SEARCH_CLUDO_ENGINE_KL = get('NEXT_PUBLIC_SEARCH_CLUDO_ENGINE_KL').required().asString();
} else {
	try {
		// Force NextJs to bake in public vars client side using direct reference to process.env
		// https://github.com/evanshortiss/env-var/issues/162
	} catch (e) {
		logger.error(e);
	}
}

export {
	DISALLOWED_CONTENT_TYPES,
	NEXT_PUBLIC_SEARCH_SITE_ID_OVERRIDE,
	NEXT_PUBLIC_SEARCH_SITE_ENV,
	NEXT_PUBLIC_SEARCH_SITE_ID,
	NEXT_PUBLIC_SEARCH_CLUDO_CLIENT_ID,
	NEXT_PUBLIC_SEARCH_CLUDO_ENGINE_DA,
	NEXT_PUBLIC_SEARCH_CLUDO_ENGINE_EN,
	NEXT_PUBLIC_SEARCH_CLUDO_ENGINE_KL,
};
